import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { PermissionService } from '../../../core/services/permission.service';
import { Router } from '@angular/router';
import { ChangePasswordComponent } from '../../../auth/change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
import { ProfileComponent } from '../../../user/profile/profile.component';
import { INavItem, navigationMenu } from '../../../core/interfaces/navigation.interface';
import { Subscription } from 'rxjs';

interface Notification {
  message: string;
  time: string;
  read: boolean;
}

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private permissionService: PermissionService
  ) { }

  currentUser: any;
  currentYear = new Date().getFullYear();
  notificationCount = 3;
  private permissionSubscription?: Subscription;
  currentPermissions: string[] = [];


  notifications: Notification[] = [
    { message: 'New company registration pending approval', time: '5 min ago', read: false },
    { message: 'Bank account application submitted', time: '1 hour ago', read: false },
    { message: 'Amendment request requires your attention', time: '2 hours ago', read: false }
  ];

  menu: INavItem[] = navigationMenu;

  itemsBySection(section: string) {
    return this.menu.filter(m => m.section === section);
  }

  hasVisibleItemsInSection(section: string): boolean {
    const items = this.itemsBySection(section);
    return items.some(item => {
      if (!item.permissions || item.permissions.length === 0) {
        return true;
      }
      // Use currentPermissions which is updated reactively
      return item.permissions.some(p => this.currentPermissions.includes(p));
    });
  }

  ngOnInit() {
    this.getLocalUser();

    this.permissionSubscription = this.permissionService.getPermissions$().subscribe(permissions => {
      this.currentPermissions = permissions;
    });
  }

  ngOnDestroy() {
    this.permissionSubscription?.unsubscribe();
  }

  getLocalUser() {
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.currentUser = user.data || user;
      } else {
        this.currentUser = null;
      }
    });
  }

  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
      width: '700px',
      disableClose: true,
      data: {},
    });
  }

  goToProfile() {
    this.dialog.open(ProfileComponent, {
      width: '700px',
      disableClose: true,
      data: {},
    });
  }

  isManagement(section: string): boolean {
    return section === 'Management';
  }

  logout() {
    this.authService.logout();
  }


}
